import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { TruncatedText } from '../../../../../../../CommonComponents/OPL/Text/TruncatedText';
import { Dot } from '../../../../../../../CommonComponents/OPL/Dot/Dot';
import { InputNumberMask } from '../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const AssetAllocationTable = () => {
  const formBag = useFormContext();

  const chartValues = useWatch({
    name: 'accountPortfolio.assets',
  });

  const [isLinked, isIntegrated, syncAssetAllocation] = formBag.watch([
    'IsLinked',
    'IsIntegrated',
    'SyncAssetAllocationEnabled',
  ]);

  if (!chartValues) {
    return null;
  }

  return (
    <Box css="margin: 0 -24px;">
      <HtmlTable variant="embedded" css="max-height: 265px; overflow-y: auto">
        <table>
          <thead>
            <tr>
              <th css="position: sticky; top: 0; z-index: 10">
                <Text variant="smallCaps" textAlign="left">
                  Name
                </Text>
              </th>

              <th css="position: sticky; top: 0; z-index: 10">
                <Text variant="smallCaps" textAlign="right">
                  Value
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            {chartValues.map((field, index) => {
              return (
                <tr key={field.id}>
                  <td>
                    <Box display="flex" alignItems="center">
                      {field.color && <Dot bg={field.color} mr="4" />}

                      <TruncatedText fontWeight={500} color="neutral.600">
                        {field.name}
                      </TruncatedText>
                    </Box>
                  </td>

                  <td>
                    <Controller
                      control={formBag.control}
                      name={`accountPortfolio.assets.${index}.y`}
                      render={({ field: { onChange, ...rest } }) => (
                        <InputNumberMask
                          {...rest}
                          placeholder="0"
                          defaultValue={field.fieldValue}
                          rightIcon="far fa-percent"
                          decimalScale={2}
                          allowNegative={false}
                          thousandSeparator={false}
                          sizeVariant="small"
                          onChange={evt => {
                            if ((isLinked || isIntegrated) && syncAssetAllocation) {
                              formBag.setValue('SyncAssetAllocationEnabled', false);
                            }

                            onChange(evt);
                          }}
                        />
                      )}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </HtmlTable>
    </Box>
  );
};
